import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const editInvoice = createAsyncThunk(
  "AgentTabs/editInvoice",
  async (data, thunkAPI) => {
    try {
      console.log('Starting invoice update with files:', data.files);
      
      // First, let's send the invoice update without files
      const invoiceResponse = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/users/v2/tabs/invoice/${data?.invoice_id}`,
        {
          ...data.schema,
          status: data.schema.status.charAt(0).toUpperCase() + data.schema.status.slice(1).toLowerCase()
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // If we have files to upload and the invoice update was successful
      if (data.files?.length && invoiceResponse.data?.invoice) {
        console.log('Invoice updated successfully, processing files');
        
        // Get the charges that have attachments from the request
        const chargesWithFiles = data.schema.charges.filter(charge => 
          charge.attachments && charge.attachments.length > 0
        );

        console.log('Charges with files:', chargesWithFiles);

        // Process each charge that has attachments
        for (const charge of chargesWithFiles) {
          console.log('Processing charge with attachments:', charge);
          
          // Find the corresponding charge ID from the response
          const updatedCharge = invoiceResponse.data.invoice.charges.find(c => 
            c.category === charge.category && 
            c.amount === charge.amount &&
            c.description === charge.description
          );

          if (updatedCharge) {
            console.log('Found matching charge in response:', updatedCharge);
            
            // Get the files for this charge
            const chargeFiles = data.files.filter(file => 
              charge.attachments.some(attachment => 
                attachment.name === file.name || attachment === file.name
              )
            );

            console.log('Files for this charge:', chargeFiles);

            if (chargeFiles.length) {
              const formData = new FormData();
              chargeFiles.forEach(file => {
                formData.append('attachments[]', file);
              });

              try {
                console.log('Uploading files for charge:', updatedCharge.id);
                const uploadResponse = await axios.post(
                  `${process.env.REACT_APP_BASE_URL}api/users/v2/tabs/charge/attachment/${updatedCharge.id}`,
                  formData,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  }
                );
                console.log('Upload response:', uploadResponse.data);
              } catch (uploadError) {
                console.error('Error uploading files:', uploadError.response?.data || uploadError);
              }
            }
          }
        }
      }

      if (invoiceResponse.data && data?.handleSuccess) {
        data?.handleSuccess();
      }
      return invoiceResponse.data?.invoice;
    } catch (error) {
      console.error('Error in editInvoice:', error);
      if (error.response) {
        if (data?.handleError) {
          data?.handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (data?.handleError) {
          data?.handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
